unable to read source [project]/node_modules/stripe/src/resources/PaymentMethodDomains.ts